<template id="travels-home-dashboard">
    <section>
<!--                <travelbanners v-show="$store.state.isLoggedIn"></travelbanners>-->

        <div class="row">
            <div class="col-md-4 col-lg-4 text-center mt-3 mb-5 ml-3" v-if="r2c1.flag === true">
                <div class="card">

                    <div class="card-header d-flex justify-content-between">

                        <div class="">{{r2c1.name}} - {{r2c1.y}} vs {{r2c1.x}}</div>
                        <a class="txt-color-white right-padding-50"
                           @click="commentBox(r2c1)">
                            <i class="fa fa-lg fa-comments"></i>
                        </a>
                    </div>

                    <div class="card-body">
                        <div id="r2c1" ref="r2c1">
                            <a class='reset'
                               @click="r2c1.resetChart()"
                               style='visibility: hidden;'>reset</a>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-md-4 col-lg-4 text-center ml-3 mt-3 mb-5" v-if="r2c2.flag === true">
                <div class="card">

                    <div class="card-header d-flex justify-content-between">

                        <div class="">{{r2c2.name}} - {{r2c2.y}} vs {{r2c2.x}}</div>
                        <a v-on:click="commentBox(r2c2)"
                           class="txt-color-white right-padding-50">
                            <i class="fa fa-lg fa-comments"></i>
                        </a>
                    </div>


                    <div class="card-body">
                        <div id="r2c2" ref="r2c2">
                            <a class='reset'
                               @click="r2c2.resetChart()"
                               style='visibility: hidden;'>reset</a>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-md-4 col-lg-3 text-center ml-3 mt-3 mb-5" v-if="r2c3.flag === true">
                <div class="card">

                    <div class="card-header d-flex justify-content-between">

                        <div class="">{{r2c3.name}} - {{r2c3.y}} vs {{r2c3.x}}</div>
                        <a v-on:click="commentBox(r2c3)"
                           class="txt-color-white right-padding-50">
                            <i class="fa fa-lg fa-comments"></i>
                        </a>
                    </div>

                    <div class="card-body">
                        <div id="r2c3" ref="r2c3">
                            <a class='reset'
                               @click="r2c3.resetChart()"
                               style='visibility: hidden;'>reset</a>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-md-4 col-lg-4 text-center ml-3 mt-3 mb-5" v-if="r2c4.flag === true">
                <div class="card">

                    <div class="card-header d-flex justify-content-between">

                        <div class="">{{r2c4.name}} - {{r2c4.y}} vs {{r2c4.x}}</div>
                        <a v-on:click="commentBox(r2c4)"
                           class="txt-color-white right-padding-50">
                            <i class="fa fa-lg fa-comments"></i>
                        </a>
                    </div>

                    <div class="card-body">
                        <div id="r2c4" ref="r2c4">
                            <a class='reset'
                               @click="r2c4.resetChart()"
                               style='visibility: hidden;'>reset</a>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-md-6 col-lg-4 text-center ml-3 mt-3 mb-5" v-if="r3c1.flag === true">
                <div class="card">
                    <div class="card-header d-flex justify-content-between">

                        <div class="">{{r3c1.name}}</div>
                        <a v-on:click="commentBox(r3c1)"
                           class="txt-color-white right-padding-50">
                            <i class="fa fa-lg fa-comments"></i>
                        </a>
                    </div>

                    <div class="card-body">
                        <div id="r3c1" ref="r3c1">
                            <a class='reset'
                               @click="r3c1.resetChart()"
                               style='visibility: hidden;'>reset</a>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-md-9 col-lg-10 text-center ml-3 mt-3 mb-5" v-if="r3c2.flag === true">
                <div class="card">
                    <div class="card-header d-flex justify-content-between">
                        <div class="">{{r3c2.name}} - {{r3c2.y}} vs {{r3c2.x}}</div>
                        <a @click="commentBox(r3c2)"
                           class="txt-color-white right-padding-50">
                            <i class="fa fa-lg fa-comments"></i>
                        </a>
                    </div>
                    <div class="card-body">
                        <div id="r3c2" ref="r3c2">
                            <a class='reset'
                               @click="r3c2.resetChart()"
                               style='visibility: hidden;'>reset</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <b-modal id="comment-box" @ok="postAnnotation()" :title="annotationTitle">
            <b-form-group label="Comment">
                <textarea rows="3" cols="50" v-model="cmnt"
                          placeholder="Write a comment..."></textarea>
            </b-form-group>
        </b-modal>

        <b-modal id="report-box" :title="reportTitle">
            <b-form-group label="Report">
                <table class="table  table-borderless">
                    <thead class="thead-light">
                    <tr>
                        <th>Time</th>
                        <th>Person</th>
                        <th>Page</th>
                        <th>Section</th>
                        <th>Comment</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(item, idx) in annotations" v-bind:key="idx">
                        <td>{{item.anTime}}</td>
                        <td class="username">{{item.anUsername}}</td>
                        <td> {{item.anPage}}</td>
                        <td> {{item.anSection}}</td>
                        <td> {{item.annotation}}</td>
                    </tr>
                    </tbody>
                </table>
            </b-form-group>
        </b-modal>
    </section>
</template>
<script>
import * as d3 from 'd3'
import * as dc from 'dc'
import * as crossfilter from 'crossfilter'
import axios from 'axios'
import {ChartInfo} from '@/models'
import {bus} from "@/bus"
//For banner in Home dashboard of Travels
    //import travelbanners from '@/components/Travels-Banner'

    export default {
        name: "travels-home-dashboard",
    //    components: { travelbanners},
        data: () => ({
            showModal: false,
            cmnt: "",

            res: "",
            levelOnePeriodData: [],
            annotations: [],
            filterPeriodLevel1: '',
            filterPeriodLevel2: 'quarterly',
            r2c1: new ChartInfo("R2C1", {}, false, []),
            r2c2: new ChartInfo("R2C2", {}, false, []),
            r2c3: new ChartInfo("R2C3", {}, false, []),
            r2c4: new ChartInfo("R2C4", {}, false, []),
            r3c1: new ChartInfo("R3C1", {}, false, []),
            r3c2: new ChartInfo("R3C2", {}, false, []),
            searching: false,
            annotationTitle: '',
            reportTitle: ''
        }),
        computed: {},
        created() {

            this.loadSummary()
            bus.$on('banner-changed', (f) => {
                this.filterPeriodLevel1 = f['l1']
                this.filterPeriodLevel2 = f['l2']
                console.log('received event', f)
                setTimeout(() => {
                    this.dcSummaryCharts()
                }, 1000)
            })
        },
        methods: {
            periodLOne: function () {
                this.filterPeriodLevel2 = 'quarterly'
                this.dcSummaryCharts()
                //  this.updateReportData()
            },
            periodLTwo: function () {
                this.dcSummaryCharts()
            },
            commentBox: function (what) {
                this.cmt = '';
                this.pg = what.name;
                this.section = what.menu;
                this.annotationHeader = "User Annotations";
                this.annotationTitle = this.annotationHeader + '->' + this.pg + '->' + this.section
                this.$bvModal.show('comment-box')
            },
            postAnnotation: function () {
                const url = '/api/annotation';
                const data = {
                    userId: 1,
                    userName: "Admin",
                    page: this.pg,
                    section: this.section,
                    comment: this.cmnt
                };
                axios.post(url, data)
                    .then(() => {
                        //DO nothing
                    }, e => {
                        console.error('error in updating annotations', e)
                    })
            },

            dcSummaryCharts: function () {
                let l1period = this.filterPeriodLevel1
                let l2period = this.filterPeriodLevel2
                let alldata = this.allSummaryData
                let data = l1period !== "" ? alldata.filter(a => a.d4l1_yyyy === l1period) : alldata;

                if (l2period === "quarterly") {
                    data.forEach(function (a) {
                        a.qt = a.d4l1_yyyy + '-Q' + a.d4l1_qq;
                    });
                } else if (l2period === "monthly") {
                    data.forEach(function (a) {
                        a.qt = a.d4l1_yyyy + '-' + a.d4l1_mm;
                    });
                }

                let alt = crossfilter(data);

                axios({url: '/json/world.json', baseURL: '', method: 'GET'}).then(res => {
                    let world = res.data

                    if (this.r3c1.flag) {
                        let r3c1 = dc.geoChoroplethChart(this.$refs.r3c1)

                        let r3c1Dimension = this.r3c1.dim
                        let r3c1Dim = alt.dimension(function (a) {
                            return a[r3c1Dimension.toLowerCase()];
                        });
                        let r3c1Group = this.r3c1.group
                        let r3c1Grp = r3c1Dim.group().reduceSum(function (a) {
                            return a[r3c1Group.toLowerCase()]
                        });
                        r3c1
                            .width(650)
                            .height(480)
                            .projection(d3.geoMercator().scale(80).translate([340, 600 / 2]))
                            .dimension(r3c1Dim)
                            .group(r3c1Grp)
                            .colors(d3.scaleOrdinal().range(["#E2F2FF", "#C4E4FF", "#9ED2FF", "#81C5FF", "#6BBAFF", "#51AEFF", "#36A2FF", "#1E96FF", "#0089FF", "#0061B5"]))
                            .colorDomain([-1000, 1000])
                            .colorCalculator(function (d) {
                                return d ? r3c1.colors()(Math.random() * 1000) : '#ccc';
                            })
                            .overlayGeoJson(world.features, "country", function (a) {
                                return a.properties.name;
                            })
                            .controlsUseVisibility(true)
                            .title((d) => {
                                return this.r3c1.x + ": " + d.key + "\n" + this.r3c1.y + ": " + Intl.NumberFormat(d.value ? (d.value / this.r3c1.div).toFixed(2) : 0) + " " + this.r3c1.unit;
                            })
                        this.r3c1.chartElem = r3c1
                    }

                    if (this.r2c1.flag) {
                        let r2c1 = dc.barChart(this.$refs.r2c1)
                        let r2c1Dim = alt.dimension(function (a) {
                            return a.qt
                        });
                        //  console.log("the group is:", this.r2c1.group)
                        let r2c1Group = this.r2c1.group
                        let r2c1Grp = r2c1Dim.group().reduceSum(function (a) {
                            return a[r2c1Group.toLowerCase()]
                        });

                        r2c1
                            .width(350)
                            .height(350)
                            .dimension(r2c1Dim)
                            .group(r2c1Grp)
                            .valueAccessor((a) => {
                                return (a.value / this.r2c1.div).toFixed(2);
                            })
                            .keyAccessor(function (a) {
                                return a.key
                            })
                            .x(d3.scaleBand())
                            .xUnits(dc.units.ordinal)
                            .gap(1)
                            .centerBar(false)
                            .elasticY(true)
                            .brushOn(false)
                            .renderLabel(false)
                            .renderTitle(true)
                            .controlsUseVisibility(true)
                            .title((a) => {
                                return this.r2c1.y + " " + (a.value / this.r2c1.div).toFixed(2) + " " + this.r2c1.unit;
                            })
                            .renderlet(function (d) {
                                d.selectAll('g.x text')
                                    .attr('transform', 'translate(-15, -30) rotate(-90)')
                            });

                        this.r2c1.chartElem = r2c1
                    }

                    if (this.r2c2.flag) {
                        let r2c2 = dc.rowChart(this.$refs.r2c2)

                        let r2c2Dimension = this.r2c2.dim
                        let r2c2Dim = alt.dimension(function (a) {
                            return a[r2c2Dimension.toLowerCase()]
                        });

                        let r2c2Group = this.r2c2.group
                        let r2c2Grp = r2c2Dim.group().reduceSum(function (a) {
                            return a[r2c2Group.toLowerCase()]
                        });

                        r2c2
                            .width(350)
                            .height(350)
                            .dimension(r2c2Dim)
                            .group(r2c2Grp)
                            .valueAccessor((a) => {
                                return (a.value / this.r2c2.div);
                            })
                            .gap(1)
                            .renderLabel(true)
                            .title((a) => {
                                return this.r2c2.y + ": " + (a.value / this.r2c2.div).toFixed(2) + " " + this.r2c2.unit
                            })
                            .renderTitle(true)
                            .controlsUseVisibility(true)
                            .xAxis.ticks = 4;

                        this.r2c2.chartElem = r2c2
                    }

                    if (this.r2c3.flag) {
                        let r2c3 = dc.pieChart(this.$refs.r2c3)

                        let r2c3Dimension = this.r2c3.dim
                        let r2c3Dim = alt.dimension(function (a) {
                            return a[r2c3Dimension.toLowerCase()];
                        });

                        let r2c3Group = this.r2c3.group
                        let r2c3Grp = r2c3Dim.group().reduceSum(function (a) {
                            return a[r2c3Group.toLowerCase()]
                        });

                        r2c3
                            .width(250)
                            .height(350)
                            .dimension(r2c3Dim)
                            .group(r2c3Grp)
                            .valueAccessor((a) => {
                                return (a.value / this.r2c3.div).toFixed(2);
                            })
                            .slicesCap(10)
                            .innerRadius(40)
                            .controlsUseVisibility(true)
                            .title((a) => {
                                return a.key + ": " + (a.value / this.r2c3.div).toFixed(2) + " " + this.r2c3.unit;
                            });

                        this.r2c3.chartElem = r2c3
                    }

                    if (this.r2c4.flag) {
                        let r2c4 = dc.rowChart(this.$refs.r2c4)

                        let r2c4Dimension = this.r2c4.dim
                        let r2c4Dim = alt.dimension(function (a) {
                            return a[r2c4Dimension.toLowerCase()];
                        });

                        let r2c4Group = this.r2c4.group
                        let r2c4Grp = r2c4Dim.group().reduceSum(function (a) {
                            return a[r2c4Group.toLowerCase()]
                        });

                        r2c4
                            .width(250)
                            .height(350)
                            .dimension(r2c4Dim)
                            .group(r2c4Grp)
                            .valueAccessor((a) => {
                                return (a.value / this.r2c4.div).toFixed(2)
                            })
                            .gap(1)
                            .renderLabel(true)
                            .controlsUseVisibility(true)
                            .title((a) => {
                                return this.r2c4.x + ": " + (a.value / this.r2c4.div).toFixed(2) + " " + this.r2c4.unit
                            })
                            .renderTitle(true)
                            .xAxis.ticks = 4;

                        this.r2c4.chartElem = r2c4
                    }

                    if (this.r3c2.flag) {
                        let r3c2 = dc.heatMap(this.$refs.r3c2)
                        let r3c2Dimension1 = this.r3c2.dim
                        let r3c2Dimension2 = this.r3c2.dim2
                        let r3c2Dim = alt.dimension(function (a) {
                            return [a[r3c2Dimension1.toLowerCase()], a[r3c2Dimension2.toLowerCase()]];
                        }); // check with Abur Rahman on data

                        let r3c2Group = this.r3c2.group
                        let r3c2Grp = r3c2Dim.group().reduceSum(function (a) {
                            return a[r3c2Group.toLowerCase()]
                        });
                        //   let r3c2Color = this.r3c2.y1color
                        // console.log("R3C2 Color range are:", r3c2Color)
                        r3c2
                            .width(1000)
                            .height(480)
                            .margins({top: 10, right: 30, bottom: 50, left: 250})
                            .dimension(r3c2Dim)
                            .group(r3c2Grp)
                            .keyAccessor(function (a) {
                                return a.key[1];
                            })
                            .valueAccessor(function (a) {
                                return a.key[0];
                            })
                            .colorAccessor(function (a) {
                                return a.value;
                            })
                            .controlsUseVisibility(true)
                            .title((a) => {
                                return `${this.r3c2.x} : ${a.key[0]}
                            ${this.r3c2.x} : ${a.key[1]}
                            ${this.r3c2.y} :  ${(a.value / this.r3c2.div).toFixed(2)}  ${this.r3c2.unit}`
                            })
                            // .colors(r3c2Color)
                            .colors(["#E2F2FF", "#C4E4FF", "#9ED2FF", "#81C5FF", "#6BBAFF", "#51AEFF", "#36A2FF", "#1E96FF", "#0089FF", "#0061B5"])
                            .calculateColorDomain();

                        this.r3c2.chartElem = r3c2

                    }

                    dc.renderAll();
                });

            },
            loadSummary: function () {
                axios.all([
                    axios.get("/api/fw_ods_monthly"),
                    axios.get("/api/fw_ods_monthly/period")]
                ).then(axios.spread((r0, r1) => {
                        this.allSummaryData = r0.data.filter(r => r.clientId===2)
                                                     console.log("ALl allSummaryData is", this.allSummaryData)

                        this.period = r1.data
                        this.levelOnePeriodData = Array.from(new Set(this.period.map(r => r.year)))

                       // this.$commonFn.auditLog("Home", "", "", "GET", "SUCCESS")

                        this.$store.dispatch("loadState").then(() => {
                            this.configData = this.$store.state.fwScreenConfig

                            // console.log("ALl vizData is", this.configData)
                            let submenuParam = this.$route.params.submenuId
                             console.log("Route Param", submenuParam)
                            let homeData = this.configData.filter(r => r.subMenuId === submenuParam)
                              console.log("All Home config data are:", homeData)
                            let getChartInfo = (vizunit) => {
                                let f = homeData.filter(r => r.positionLogical === vizunit)
                                if (f.length === 0) return new ChartInfo(vizunit, {}, false, [])
                                return new ChartInfo(vizunit, f[0], f[0]['visibleFlag'], f)
                            }
                            this.r2c1 = getChartInfo("R2C1")
                            //console.log("THE R2C1 data", this.r2c1)
                            this.r2c2 = getChartInfo("R2C2")
                            this.r2c3 = getChartInfo("R2C3")
                            this.r2c4 = getChartInfo("R2C4")
                            this.r3c1 = getChartInfo("R3C1")
                            this.r3c2 = getChartInfo("R3C2")

                            setTimeout(() => {
                                this.dcSummaryCharts()
                            }, 1000)
                        })
                    }, err => {
                        console.error('error in fetching home dashboard data', err)
                       // this.$commonFn.auditLog("Home", "", "", "GET", err)
                    }
                ))


            }
        }
    };
</script>
<style scoped>

</style>